import { DRIVER_IDS } from "../constants/driverIds";
import { PERIOD_TYPES } from "../constants/keywords";

// RFC 5322 compliant email regex (simplified - covers most valid addresses)
export const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
export const isValidEmail = (email) => typeof email === "string" && email.trim() !== "" && EMAIL_REGEX.test(email.trim());

/** Consolidated export warning when selected hotels lack a published plan for the chosen year/type. */
export const getConsolidatedPlanWarningMessage = (missingCount, totalCount) => {
  const missing = Number(missingCount) || 0;
  const total = Number(totalCount) || 0;
  return `${missing} of ${total} hotels do not have a published plan of this type and will be excluded from consolidated totals. See the Data Summary tab for details.`;
};

class Helper {
    getDriverConfig(rowData) {

      let config = JSON.parse(rowData.driverConfig);
  
      if (config == null || config == undefined) {
        config = {
          period: PERIOD_TYPES.MONTHLY,
          values: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          adjustmentValues: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        };
      }
  
      // For driver ID 14 (multi-driver), return ONLY the numbered breakdown objects
      if (rowData.driverId == DRIVER_IDS.MULTI_DRIVER) {
        // Create new config with ONLY numbered keys
        const cleanConfig = {};
        Object.keys(config).forEach(key => {
          if (!isNaN(key)) {
            cleanConfig[key] = config[key];
          }
        });
        
        // Preserve essential properties that might be needed by template functions
        if (config.standardHoursPeriod !== undefined) {
          cleanConfig.standardHoursPeriod = config.standardHoursPeriod;
        }

        return cleanConfig; // Return numbered objects with essential properties
      }
  
      // For other driver types, process normally (existing logic)
      if (!Array.isArray(config.aggregatedValues)) {
        config.aggregatedValues = [];
      }
      while (config.aggregatedValues.length < 12) {
        config.aggregatedValues.push(0);
      }
  
      if (!Array.isArray(config.values)) {
        config.values = [];
      }
      while (config.values.length < 12) {
        config.values.push(0);
      }
  
      if (!Array.isArray(config.adjustmentValues)) {
        config.adjustmentValues = [];
      }
      while (config.adjustmentValues.length < 12) {
        config.adjustmentValues.push(0);
      }
  
      if (config.isCompRoomSelected == null) {
        config.isCompRoomSelected = false;
      }
  
      if (!Array.isArray(config.structureCodeIdsList)) {
        config.structureCodeIdsList = [];
      }

      if (!Array.isArray(config.departmentIds)) {
        config.departmentIds = [];
      }
      if (!Array.isArray(config.departmentMappingIds)) {
        config.departmentMappingIds = [];
      }

      if (rowData.driverId == DRIVER_IDS.PER_KEY && (config?.keys == null || config?.keys == 0)) {
        config.keys = 150;
      } 

      if (!Array.isArray(config.periodAggregatedValues)) {
        config.periodAggregatedValues = [];
      }
      while (config.periodAggregatedValues.length < 12) {
        config.periodAggregatedValues.push(0);
      }

            // For other driver types, process normally (existing logic)
      if (!Array.isArray(config.minGuardrails)) {
        config.minGuardrails = [];
      }
      while (config.minGuardrails.length < 12) {
        config.minGuardrails.push(0);
      }

            // For other driver types, process normally (existing logic)
      if (!Array.isArray(config.maxGuardrails)) {
        config.maxGuardrails = [];
      }
      while (config.maxGuardrails.length < 12) {
        config.maxGuardrails.push(0);
      }

      const driverId = Number(rowData.driverId);
      const compRoomDriverIds = [
        DRIVER_IDS.PER_OCCUPIED_ROOM,
        DRIVER_IDS.MINUTES_PER_ROOM,
        DRIVER_IDS.EMPLOYEE_HOURS,
      ];
      if (config.isCompRoomSelected === true && compRoomDriverIds.includes(driverId)) {
        const len = config.aggregatedValues.length;
        const existing = Array.isArray(config.compRoomValues) ? config.compRoomValues : [];
        config.compRoomValues = Array.from({ length: len }, (_, i) => {
          const n = Number(existing[i]);
          return Number.isFinite(n) ? n : 0;
        });
      }

      return config;
  }

      isNull(elem){
        return elem==null || elem==undefined;
      }

      subtract(a,b){
        if(!this.isNull(a) && !this.isNull(b))
          return parseFloat(a-b).toFixed(2);

        return "error"
      }

      getFloatValue(val, decimalDigits = 2){
        if(this.isNull(val))return val;
        return  parseFloat(val.toFixed(decimalDigits));
      }
        
      getInitialsFromFullName(name){
        if(this.isNull(name))return name;
        return name.split(' ').filter(part => part.trim() !== '').map(part => part[0].toUpperCase()).join(''); 
      }

      getNameWithLastNameAsInitial(name) {
        if(this.isNull(name))return name;
        return name.split(' ').filter(part => part.trim() !== '').map((part, index) => index === 0 ? part : part[0].toUpperCase() + '.').join(' ');
      }

      matchStringNotCaseSensitive(source, target) {
        return source?.toLowerCase().includes(target?.toLowerCase());
      }
      
      capitalize(str) {
        if(this.isNull(str)) return str;
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      }
      
      sum(arr) {
        return arr.reduce((a, b) => a + b, 0);
      }

      resolveDepartmentAggregationLabel(key, departmentNameById, mappingSubNameById) {
        if (key == null || key === "") return key;
        const k = String(key);
        const n = Number(key);
        const dept =
          departmentNameById?.[k] ??
          departmentNameById?.[n];
        if (dept != null && dept !== "") return dept;
        const sub =
          mappingSubNameById?.[k] ??
          mappingSubNameById?.[n];
        if (sub != null && sub !== "") return sub;
        return key;
      }
}

const helper = new Helper();

export default helper;